import { getGroupedBudgets } from "./getGroupedBudgets";
import { getGroupedInvestmentBudgets } from "./getGroupedInvestmentBudgets";

export function getGroupedBudgetsByType({
	budgets,
	categories,
	transactions,
	wallets,
}) {
	const byType = (type) => ({
		categories: categories.filter((c) => c.type === type),
		budgets: budgets.filter((b) => b.type === type),
		transactions: transactions.filter(
			(t) =>
				t.type === type &&
				t.includeInAnalysis === true &&
				t.investmentDebtPayoff === "",
		),
	});

	return {
		income: getGroupedBudgets(
			byType("income").budgets,
			byType("income").categories,
			byType("income").transactions,
		),
		expense: getGroupedBudgets(
			byType("expense").budgets,
			byType("expense").categories,
			byType("expense").transactions,
		),
		investment: getGroupedInvestmentBudgets({
			wallets,
			budgets,
			transactions,
		}),
	};
}
